let apipath = "https://app.suorapalaute.fi/api/v1"
let urlpath = "https://app.suorapalaute.fi/"
if (window.location.port && window.location.port.indexOf('3000')>-1) {
    apipath = "http://localhost:8080/api/v1"
    urlpath = "http://localhost:3000/"
}
export const API = apipath;
export const URL = urlpath;